export default "<r-card-onboarding #onboardingViews></r-card-onboarding>\n";